import Tileset from "./Grid";
import styled from "styled-components";
import { motion } from "framer-motion";
//Style tutaj
const PortfolioBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 85vh;
  background-color: #798460;
  & > h1 {
    margin: 6vh;
    margin-bottom: 10vh;
    font-size: 14vh;
    color: #2e1919;
  }
  @media screen and (max-width: 479px) {
    & > h1 {
      font-size: 10vh;
    }
  }
`;
function Portfolio() {
  return (
    <PortfolioBody
      id="jump"
      as={motion.div}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <h1>Portfolio</h1>

      <Tileset />
    </PortfolioBody>
  );
}

export default Portfolio;
